import {useState} from 'react'
import {BasicBreadcrumbs} from 'src/app/shared/BasicBreadcrumbs'
import {KTCard} from '../../../../_metronic/helpers'
import {PartnerContext} from './PartnerContexts'
import {SolicitudesListHeader} from './components/SolicitudesListHeader'
import {SolicitudesTable} from './components/SolicitudesTable'
import {InfoModalCandidato} from './show-info-candidato/InfoModalCandidato'
import {InfoModal} from './show-info-modal/InfoModal'

const historialDocumentsBreadcrumbs = [
  {
    title: 'Seguimiento',
    path: '/seguimiento/solicitudes',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const SolicitudesPage = () => {
  const [activeOnly, setActiveOnly] = useState('PENDIENTE')
  const [state, setState] = useState<string[]>([])
  const [searchTerm, setSearchTerm] = useState('')
  const [entryDateFrom, setEntryDateFrom] = useState()
  const [entryDateTo, setEntryDateTo] = useState()
  const [idRegistroFicha, setIdRegistroFicha] = useState('')
  const [isInfoModalOpen, setIsInfoModalOpen] = useState<boolean>(false)
  const [isInfoModalCandidatoOpen, setIsInfoModalCandidatoOpen] = useState<boolean>(false)
  const [infoData, setInfoData] = useState<{}>({})
  const [updateUser, setUpdateUser] = useState(false)

  return (
    <>
      <PartnerContext.Provider
        value={{
          activeOnly,
          setActiveOnly,
          state,
          setState,
          searchTerm,
          setSearchTerm,
          entryDateFrom,
          setEntryDateFrom,
          entryDateTo,
          setEntryDateTo,
          isInfoModalOpen,
          setIsInfoModalOpen,
          isInfoModalCandidatoOpen,
          setIsInfoModalCandidatoOpen,
          infoData,
          setInfoData,
          updateUser,
          setUpdateUser,
        }}
      >
        <BasicBreadcrumbs breadcrumbs={historialDocumentsBreadcrumbs} fallbackTitle='Solicitudes' />
        <KTCard>
          <SolicitudesListHeader />
          <SolicitudesTable />
        </KTCard>
        <InfoModal />
        <InfoModalCandidato />
      </PartnerContext.Provider>
    </>
  )
}

export {SolicitudesPage}
